import styled from 'styled-components';

const Wrapper = styled.div`
  .buyerListSkeleton {
    margin: 16px 0px;
    .sub-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .left-side {
        display: flex;
        min-width: 54px;
        height:auto;
        .skeleton-box {
          width: 30px;
          height: 24px;
          border-radius: 4px;
        }
        .details {
          padding-left: 15px;
          display:flex;
          flex-direction:column;
          .skeleton-box {
            height: 20px;
            border-radius: 25px;
            width: 50px;
            &.title-box {
              height: 10px;
              border-radius: 20px;
              width: 120px;
              margin-bottom:5px;
            }
            &.title-box-short{
              height: 10px;
              border-radius: 20px;
              width: 150px;
              margin-bottom:7px;
            }
          }  
        }
      }
    }
  }
  
`;
const BuyerGroupListSkeleton = function BuyerGroupListSkeleton() {
  return (
    <Wrapper>
      <div className="buyerListSkeleton">
        {[1, 2, 3, 4, 5].map(() => (
          <div className="sub-container">
            <div className="left-side">
              <span className="skeleton-box" />
              <div className="details">
                <span className="skeleton-box title-box" />
                <span className="skeleton-box title-box-short" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </Wrapper>
  );
};
export default BuyerGroupListSkeleton;
